import { Box } from "@mui/material";

import { P1 } from "@/Components";
import { RetangleToggle } from "@/Components/SwitchToggle/RectangleToggle";

import SortSection from "./SortSection";

const NewGraphHeader = (props) => {
  const {
    toggles = {
      isShow: false,
      allToggles: [],
    },
    revenue = {
      isShow: false,
    },
    dollar = {
      isShow: false,
    },
    sort = {
      isShow: false,
    },
    yAxisLabel = "",
  } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "space-between",
        alignItems: "center",
        marginBottom: "10px",
      }}
    >
      <P1 fSize={10} fweight={600}>
        {yAxisLabel}
      </P1>
      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "flex-end",
          alignItems: "center",
        }}
      >
        {toggles.isShow &&
          toggles.allToggles.map((toggle, toggleIndex) => (
            <RetangleToggle
              isSelected={toggle.isSelected}
              handleIsSelected={toggle.handleIsSelected}
              selectedLabel={toggle.selectedLabel}
              unSelectedLabel={toggle.unSelectedLabel}
              key={`toggle-${toggleIndex}`}
            />
          ))}
        {revenue.isShow && (
          <RetangleToggle
            isSelected={revenue.isRevenueData}
            handleIsSelected={revenue.handleIsRevenueData}
            selectedLabel={revenue.selectedLabel}
            unSelectedLabel={revenue.unSelectedLabel}
          />
        )}

        {dollar.isShow && (
          <RetangleToggle
            isSelected={!dollar.isDollarData}
            handleIsSelected={dollar.handleIsDollarData}
            selectedLabel={dollar.selectedLabel}
            unSelectedLabel={dollar.unSelectedLabel}
            isNewUnSelectBkg={revenue.isRevenueData}
          />
        )}
        {sort.isShow && (
          <SortSection
            sortCheckbox={sort.sortCheckboxStatus}
            handleSortCheckbox={sort.handleSortCheckbox}
          />
        )}
      </Box>
    </Box>
  );
};

export default NewGraphHeader;
